import Swiper from "swiper";

const productPageSlider = document.querySelector(".js-product-page-card__slider");

if (productPageSlider) {
    initProductPageSlider(productPageSlider);
}

function initProductPageSlider(slider) {
    const swiperWrap = slider.querySelector(".js-product-page-slider");
    const thumbs = slider.querySelector(".js-product-page-slider-thumbs");

    let pageSliderThumbs = null;

    if (!window.mobileMedia && thumbs) {
        const thumbsSlides = thumbs.querySelectorAll(".swiper-slide");

        if (thumbsSlides.length > 6) {
            for (let i = 6; i < thumbsSlides.length; i++) {
                thumbsSlides[i].style.display = "none";
            }

            thumbs.insertAdjacentHTML(
                "beforeend",
                "<span class='simple-link js-open-fancybox'>Все фото</span>",
            );
        }

        pageSliderThumbs = new Swiper(thumbs, {
            slidesPerView: "auto",
            direction: "vertical",
        });
    }

    if (swiperWrap) {
        const slides = swiperWrap.querySelectorAll(".swiper-slide");

        if (slides.length > 1) {
            const swiper = new Swiper(swiperWrap, {
                spaceBetween: 10,
                watchOverflow: true,

                pagination: {
                    el: ".js-product-page-card-pagination",
                    clickable: true,
                },
                thumbs: {
                    swiper: pageSliderThumbs,
                },
            });

            const btn = thumbs.querySelector(".js-open-fancybox");

            if (btn) {
                btn.addEventListener("click", () => {
                    swiper.slideTo(0);
                    slides[0].querySelector("img").click();
                });
            }
        }
    }
}
